import { observer } from 'mobx-react-lite';
import { useTranslation } from 'next-i18next';
import styles from '@features/productPreview/sections/ProductDescription/components/ProductDescriptionBlock/ProductTechnicalPicture.styles';
import reusables from '@styles/theme/reusables';
import { WindowType } from '@typescript/index';
import { ContentTechnicalPhotoItemType, PhotoSizeType } from '@features/productPreview/sections/ProductDescription/typescript';
import { uiState } from '@features/productPreview/mobX/state/context';
import { getImage } from '@features/productPreview/sections/ProductDescription/helpers';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  picture: ContentTechnicalPhotoItemType;
  windowType: WindowType;
  setIsOpenGallery: (active: boolean) => void;
};
const ProductTechnicalPicture = ({
  picture,
  windowType,
  setIsOpenGallery
}: PropsType) => {
  const {
    showSlider,
    productName
  } = uiState;
  const {
    t
  } = useTranslation('common');
  const pictureAlt = [productName, t('accessibility.technicalDrawing')].filter(Boolean).join(' ');
  let getImageSrc: string = getImage(picture, PhotoSizeType.MEDIUM);
  if (windowType === WindowType.tablet) {
    getImageSrc = getImage(picture, PhotoSizeType.NORMAL);
  }
  if (windowType === WindowType.desktop) {
    getImageSrc = getImage(picture, PhotoSizeType.FULL);
  }
  const handleOpenGallery = (techPicture: ContentTechnicalPhotoItemType) => {
    showSlider(techPicture);
  };
  return <div sx={styles.technicalPicturesContainer}>
      <button type="button" sx={{
      ...styles.technicalPictureImage,
      ...reusables.unstyledButton
    }} onClick={() => {
      handleOpenGallery(picture);
      setIsOpenGallery(true);
    }} data-cy="TechnicalPictureImage">
        <ResponsiveImage image={getImageSrc} alt={pictureAlt} objectFit="contain" objectPosition="center" />
      </button>
    </div>;
};
export default observer(ProductTechnicalPicture);